import controller from './row-details-modal.controller';
import template from './row-details-modal.html';
import './row-details-modal.scss';

/**
 *
 * @param {{ resolve: Utils.ToResolve<RowDetailsModalType.Resolve> }} param0
 */
const component = ({ resolve }) => {
	/** @type {Utils.ToResolve<import('ts-essentials').DeepRequired<RowDetailsModalType.Resolve>>} */
	const finalResolve = {
		kid: resolve.kid,
		locked: resolve.locked ?? (() => true),
		readonly: resolve.readonly ?? (() => true),
	};

	return ({
		template,
		resolve: finalResolve,
		controller,
		controllerAs: '$ctrl',
		windowClass: 'row-details-modal',
	});
};

export default component;
